import { ScriptService } from './services/script/script.service';
import { IpServiceService } from './services/IpService/ip-service.service';
import { NgModule, ErrorHandler, SkipSelf, Optional, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractsService } from '@app/core/services/contracts/contracts.service';
import { ContactService } from './services/contact/contact.service';
import { UserService } from '@app/core/services/user/user.service';
import { HeaderModule } from '@app/core/header/header.module';
import { FooterModule } from '@app/core/footer/footer.module';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { JWTInterceptor } from './interceptors/jwt/jwt.interceptor';
import { ErrorInterceptor } from './interceptors/error/error.interceptor';
import { ResolutionService } from './services/resolution/resolution.service';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthTokenService } from './services/auth-token/auth-token.service';
import { ErrorHandlerService } from './error-handler/error-handler.service';
import { MarkdownModule } from 'ngx-markdown';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPTBRPaginatorIntl } from './paginator/PT_BR.paginator.intl';
import { registerLocaleData } from '@angular/common';

import ptLocale from '@angular/common/locales/fr';
import { FileService } from '@app/core/services/file/file.service';

registerLocaleData(ptLocale, 'pt');

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    MarkdownModule.forRoot({ loader: HttpClient }),
    CommonModule,
    HeaderModule,
    FooterModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('currentUserJwtToken');
        },
        headerName: 'Authorization',
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MatPaginatorIntl, useValue: getPTBRPaginatorIntl() },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: 'Window', useValue: window },
    { provide: LOCALE_ID, useValue: 'pt' },
    ContractsService,
    UserService,
    ResolutionService,
    AuthTokenService,
    ContactService,
    ScriptService,
    IpServiceService,
    FileService,
  ],
  exports: [HeaderModule, FooterModule],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
